module.exports = __webpack_public_path__ + "static/img/zxk.5212087.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zxk.jpg
// module id = T/18
// module chunks = 1